import React from 'react';
import ProductTile from './ProductTile';
import { createLCYourTitlesProductDetailLink } from './utils/product-detail-link-helpers';
import { DISPLAY_TYPE_LIST, DISPLAY_TYPE_MINIMAL, DISPLAY_TYPE_TILE } from '../../../store/displayType/types';
import { log } from '../../../shared/utils/log';
import ListItem from './ListItem';
import { ProductOut } from '../../../store/api';
import { COLLECTION_NAVIGATION_V2, useFeature } from '../../../shared/utils/togglz';

interface Props {
    displayType: typeof DISPLAY_TYPE_LIST | typeof DISPLAY_TYPE_MINIMAL | typeof DISPLAY_TYPE_TILE;
    product: ProductOut;
}
const ProductElement = (props: Props) => {
    const isCollectionNavigationV2Enabled = useFeature(COLLECTION_NAVIGATION_V2);
    const productLinkUri = createLCYourTitlesProductDetailLink(props.product.id ?? '', isCollectionNavigationV2Enabled);
    const isYourTitle = true;
    const isLibxchange = false;
    const isInCollection = false;

    if (props.displayType === DISPLAY_TYPE_LIST) {
        return (
            <ListItem
                isYourTitle={isYourTitle}
                isLibxchange={isLibxchange}
                isInCollection={isInCollection}
                productLinkUri={productLinkUri}
                product={props.product}
                shopLanguage={undefined}
            />
        );
    } else if (props.displayType === DISPLAY_TYPE_MINIMAL || props.displayType === DISPLAY_TYPE_TILE) {
        return (
            <ProductTile
                isYourTitle={isYourTitle}
                isLibxchange={isLibxchange}
                isInCollection={isInCollection}
                productLinkUri={productLinkUri}
                product={props.product}
                displayType={props.displayType}
                shopLanguage={undefined}
            />
        );
    } else {
        log.warning('Please check the display type given to the component ProductElement');
        return <div />;
    }
};

export default ProductElement;
